import React, { useCallback } from "react";
import T from "prop-types";

import { Theme } from "2g-widget";
import { Icons } from "2g-icons";

import useRedirect from "b2b/hooks/useRedirect";
import { PATHS } from "b2b/constants";
import Authorized from "b2b/components/auth";

import useMessages from "./i18n/useMessages";

function HeaderActions({ provozniInformace }) {
  const messages = useMessages();
  const redirect = useRedirect();

  const redirectToEditace = useCallback(() => {
    redirect(PATHS.PROVOZNI_INFORMACE.EDITACE, { id: provozniInformace.id });
  }, [redirect, provozniInformace?.id]);

  return provozniInformace?.id !== undefined
    ? [
        <Authorized
          key="action-Edit"
          roles={["admin", "vuz_spravce", "vuz_edit"]}
        >
          <Theme.HeaderAction onClick={redirectToEditace}>
            <Icons.Edit />
            <span>{messages.pageHeadingEdit()}</span>
          </Theme.HeaderAction>
        </Authorized>
      ]
    : null;
}

HeaderActions.propTypes = {
  provozniInformace: T.shape({ id: T.oneOfType([T.string, T.number]) })
};

export default React.memo(HeaderActions);
